import { DateRange, DateRangePicker, DateRangePickerProps } from '@blueprintjs/datetime'
import React from 'react'
import { UPRIGHT_EPOCH } from '../utils'
import { toStartOfDay, toEndOfDay, isValidDate } from '../utils/dateHelpers'
import { MomentDateRange } from './MomentDate'

interface UprightDateRangePickerProps extends Partial<DateRangePickerProps> {
  onChange: (range: DateRange) => void
  value?: DateRange
}

const onChangeWrapper =
  (fn: (range: DateRange) => void) =>
  ([start, end]: DateRange) => {
    const needsAdjustment = start === null && end !== null
    const adjStart = needsAdjustment ? end : start
    const adjEnd = needsAdjustment ? null : end

    const dateOrNull = (d: Date | null): Date | null => (isValidDate(d) ? d : null)
    fn([dateOrNull(adjStart) && toStartOfDay(adjStart), dateOrNull(adjEnd) && toEndOfDay(adjEnd)])
  }

const UprightDateRangePicker: React.FC<UprightDateRangePickerProps> = props => (
  <div>
    <DateRangePicker
      className="center-datepicker"
      singleMonthOnly
      allowSingleDayRange
      shortcuts={false}
      minDate={UPRIGHT_EPOCH}
      maxDate={new Date()}
      {...props}
      onChange={onChangeWrapper(props.onChange)}
    />
    {props.value && <MomentDateRange range={props.value} />}
  </div>
)

export default UprightDateRangePicker
